import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-474c6c91")

_pushScopeId("data-v-474c6c91")
const _hoisted_1 = { class: "order-list" }
const _hoisted_2 = { class: "mypage-title -bold" }
const _hoisted_3 = { class: "order-list--table" }
const _hoisted_4 = { class: "month" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Order = _resolveComponent("Order")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.t('paid list')), 1),
    _createVNode("section", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.values(_ctx.groupBy()), (i) => {
        return (_openBlock(), _createBlock(_Fragment, { key: i }, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", null, _toDisplayString(_ctx.displayMonth(i[0]["PaidMonth"].toString())), 1)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(i, (j) => {
            return (_openBlock(), _createBlock(_component_Order, {
              key: j,
              class: "order",
              item: j,
              onClick: ($event: any) => {_ctx.orderClick(j);}
            }, null, 8, ["item", "onClick"]))
          }), 128))
        ], 64))
      }), 128))
    ])
  ]))
})